/* @ngInject */
export default function (params) {
	let {
		    $scope,
		    toastr,
		    PermissionsCategories,
		    PermissionsGates,
		    PermissionsUsers,
		    PermissionsServiceUsers,
		    STATUSES,
		    $q,
	    } = params;

	$scope.permissionsStatus = STATUSES.UNLOADED;

	$scope.permissionsTypes = {
		'gate':        'Gate',
		'category':    'Category',
		'user':        'User',
		'serviceUser': 'Service User',
		'public':      'Public Access',
	};

	$scope.permissionsDirectoryPermissions = {
		'BROWSE': 'Browse',
		'EDIT':   'Edit / Move',
		'DELETE': 'Delete',
		'UPLOAD': 'New Directory / Upload Document',
	};

	$scope.permissionsDocumentPermissions = {
		'DOWNLOAD': 'Download',
		'EDIT':     'Edit / Move',
		'DELETE':   'Delete',
		'UPLOAD':   'Upload New Version',
	};

	$scope.refreshPermissions = () => {
		$scope.permissionsStatus = STATUSES.LOADING;

		$q.all([
			  PermissionsGates.getList(),
			  PermissionsCategories.getList(),
			  PermissionsUsers.getList({
				  include: 'workable',
			  }),
			  PermissionsServiceUsers.getList(),
		  ])
		  .then((results) => {
			  const permissionsGates        = results[0];
			  const permissionsCategories   = results[1];
			  const permissionsUsers        = results[2];
			  const permissionsServiceUsers = results[3];

			  $scope.permissionsGates        = permissionsGates;
			  $scope.permissionsCategories   = permissionsCategories;
			  $scope.permissionsUsers        = permissionsUsers;
			  $scope.permissionsServiceUsers = permissionsServiceUsers;

			  $scope.permissionsStatus = STATUSES.LOADED;
		  })
		  .catch((error) => {
			  toastr.clear();
			  toastr.error('There was an error while loading the list of permissions, please try again.', 'Error');

			  $scope.permissionsStatus = STATUSES.ERRORED;
		  });
	};
}


// WEBPACK FOOTER //
// ./src/js/endpoints/supportWorker/documents/root/controllers/permissions/index.js